export default "__VITE_ASSET__YH1akgYC__"